import { useMemo } from 'react';
import tarsUtil from '@alife/cn-tars-util';
const DEFAULT_KEY = 'ONE_SEARCH_DATE_STORE_KEY';
const useTars = typeof window.__tars_config__ === 'object' && window.__tars_config__;
export default (key) => {
    const storageKey = useMemo(() => `${DEFAULT_KEY}_${key}`, [key]);
    async function getData() {
        const resNext = await tarsUtil.ajax({
            url: '/api/open/habit/listActions',
            method: 'GET',
            data: { habitKey: storageKey },
            skipValidate: true,
        });
        const { index: actionId, data: habitData = {} } = resNext?.data?.[0] || {};
        return {
            actionId,
            habitData,
        };
    }
    const get = async () => {
        if (!useTars) {
            try {
                const res = localStorage.getItem(storageKey);
                if (res) {
                    return JSON.parse(res);
                }
                return null;
            }
            catch {
                return null;
            }
        }
        else {
            const res = await getData();
            localStorage.setItem(storageKey, JSON.stringify(res));
            return res;
        }
    };
    const add = async (data) => {
        if (!useTars) {
            try {
                localStorage.setItem(storageKey, JSON.stringify({
                    actionId: new Date().getTime(),
                    habitData: JSON.stringify(data),
                }));
                return Promise.resolve({
                    success: true,
                });
            }
            catch {
                return Promise.reject(new Error('add habit data failed, please try again later'));
            }
        }
        return tarsUtil.ajax({
            url: '/api/open/habit/addAction',
            method: 'POST',
            data: {
                habitKey: storageKey,
                action: JSON.stringify(data),
            },
            skipValidate: true,
        });
    };
    return {
        get,
        add,
    };
};
